import { z } from 'zod';
import { requiredString } from '../helpers';
export const Twilio_Update_Consent_1_ConfigValidator = z.object({
    smsPhoneNumber: requiredString('SMS Phone Number is required'),
    customerPhoneNumber: requiredString('Customer Phone Number is required'),
    status: z.enum(['opt-in', 'opt-out'])
});
//# sourceMappingURL=twilio-update-consent-1.js.map